import * as React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import { FormControl, InputLabel, Input, FormHelperText, Alert, Select, Skeleton} from "@mui/material"
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { Divider, IconButton, Typography } from '@mui/material';
import { printVariable } from '@util/helper';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { useMediaQuery, useTheme } from "@mui/material";
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import useAlert from "@hooks/useAlert"
import MenuItem from '@mui/material/MenuItem';
import { Grid } from "@mui/material/"

const defSmst = {id:-1, year:'', gisu: ''}
const ManagerLecturePartPriorUpload = React.forwardRef((props, ref) =>  {
  const {callback} = props
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const schola = useSelector(state => state.scholaReducer)
  const [file, set_file] = React.useState(null)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const {alert, renderAlert} = useAlert()
  const [smst, set_smst] = useState(defSmst)
  const [smstList, set_smstList] = useState([])
  const [open, set_open] = React.useState(false)
  const updateRef = React.useRef(false)
  const respectGradeRef = React.useRef({checked:true})
  const respectScheduleRef = React.useRef({checked:true})

  const onChangeSmstId = (e) => {
    const smst = smstList.find(r => r.id === e.target.value)
    if(smst) {
      set_smst(smst)
    }
  }

  const onChangeFile = (e) => {
    const file = e.target.files[0]
    set_file(file)
  }
  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return
    }
    else {

      if(callback && updateRef.current) {
        callback()
      }
      set_smst(defSmst)
      set_file(null)
      set_open(false)
    }
  }

  const handleOpen = () => {
    set_open(true)
  }

  React.useImperativeHandle(ref, () =>({
    open: () => {
      handleOpen()
    },
    close: () => {
      handleClose()
    }
  }))

	const fetchSmst = async () => {
		const url = `/smst/standby/lecture/${schola.id}`
    openIndicator()
		const resp = await WebService.get(url, {})
    closeIndicator()
		if (resp.repCode !== "ack") {
			// openSnackbar(resp.repMessage);
			alert(resp.repMessage)
			return
		}
		const repMessage = JSON.parse(resp.repMessage)
		const smst = JSON.parse(repMessage.smst)
		return smst
	}

  const fetchSmstList = async() => {
		const url = `/smst/last/2/${schola.id}`
    openIndicator()
		const resp = await WebService.get(url, {})
    closeIndicator()
		if (resp.repCode !== "ack") {
			alert(resp.repMessage)
			return
		}

		const repMessage = JSON.parse(resp.repMessage)
		const smstList = JSON.parse(repMessage.records)
		return smstList.filter(r => r.phase != 2)
  }

  const onUpload = async() => {
    if(!smst.id) {
      alert('년도/기수를 선택해 주세요.')
      return
    }

    const url = `/regi/upload/${schola.id}/${smst.id}`
    const formData = new FormData()

    const params = {
      respectGrade: respectGradeRef.current.checked,
      respectSchedule: respectScheduleRef.current.checked
    }

    if(file != null) {
      // formData.append(`files`, file)
      const f = new File([file], file.name, { type: file.type }) 
      formData.append(`files`, f)

      openIndicator()
      const resp = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        params: params
      })
      closeIndicator()


      if (resp.data.repCode !== 'ack') {
        alert(resp.data.repMessage)
        return
      }

      set_file(null)
      updateRef.current = true
      alert('저장되었습니다.', handleClose)
    }
  }

  const onLoad = async() => {
    if(open) {
      const smstList = await fetchSmstList()
      if(smstList) {
        set_smstList(smstList)
        if(smstList.length == 1) {
          set_smst(smstList[0])
        }
      }
    }
  }

  React.useEffect(() => {
    if(open) {
      onLoad()
    }
  },[open])

  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            {schola.name} 
          </Typography>
          <Typography variant='body' align='center'>대리신청 파일 업로드</Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <label>
                    <input type='checkbox' defaultChecked={true} ref={respectGradeRef} /> 대상학년 검사
                  </label>
                </Grid>
                <Grid item xs={6}>
                  <label>
                    <input type='checkbox' defaultChecked={true}  ref={respectScheduleRef} /> 일정중복 검사
                  </label>
                </Grid>
              </Grid>

            </Grid>
 
            <Grid item xs={12}>
              <FormControl fullWidth sx={{mt:2, mb:2}}>
                <InputLabel id='gisu' size='small'>
                  년도/기수
                </InputLabel>
                    <Select
                      labelId='gisu'
                      required
                      label='년도/기수'
                      name={"smstId"}
                      value={smst?.id}
                      size='small'
                      onChange={async (e) => {
                        onChangeSmstId(e)
                      }}>
                      {smstList.map((s, index) => {
                        return (
                          <MenuItem key={index} value={s.id}>
                            {s.year}/{s.gisu}
                          </MenuItem>
                        )
                      })}
                    </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="standard"          
                type="text"
                value={file? file.name: ''}
                fullWidth
                label ="대리신청 목록 파일"
                InputLabelProps={{shrink: file}}
                InputProps={{
                  endAdornment: (
                    <IconButton component="label">
                      <AttachFileOutlinedIcon/>
                      <input
                        styles={{display:"none"}}
                        type="file"
                        accept='.xls, .xlsx'
                        hidden
                        onChange={(e)=> {onChangeFile(e)}}
                      />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Button onClick={handleClose}>취소</Button>
          <Button onClick={onUpload} variant='contained' disabled={file === null || smst.id == -1}>업로드</Button>
        </DialogActions>
      </Dialog>
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
		
	)
})

export default ManagerLecturePartPriorUpload
